import { render, staticRenderFns } from "./openQuestion.vue?vue&type=template&id=17a85e9e&scoped=true"
import script from "./openQuestion.vue?vue&type=script&lang=js"
export * from "./openQuestion.vue?vue&type=script&lang=js"
import style0 from "./openQuestion.vue?vue&type=style&index=0&id=17a85e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a85e9e",
  null
  
)

export default component.exports